import { render, staticRenderFns } from "./ParkingConfig.vue?vue&type=template&id=1903f148&"
import script from "./ParkingConfig.vue?vue&type=script&lang=js&"
export * from "./ParkingConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports